import './footer.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { COMPANY, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL, SOCIAL } from "../../config/company";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className='footer'>
      <div className='footer_container'>
        <div className='footer_container_list'>
          {/* ====== Notre entreprise ====== */}
          <div className='footer_container_list_block'>
            <p className='footer_container_list_title'>Notre entreprise</p>
            <ul className='footer_links'>
              <li><Link to="/about" className='footer_link'>À propos de nous</Link></li>
              <li><Link to="/careers" className='footer_link'>Carrières</Link></li>
              <li><Link to="/help" className='footer_link'>Besoin d'aide ?</Link></li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} className='footer_link'>Nous contacter</a>
              </li>
              <li>
                <a href={`tel:${CONTACT_PHONE_TEL}`} className='footer_link'>{CONTACT_PHONE}</a>
              </li>
            </ul>
            <div className="footer_company_legal">
              <p>{COMPANY.legalForm}</p>
              <p>SIREN {COMPANY.siren}</p>
              <p>SIRET {COMPANY.siret}</p>
              <p>TVA {COMPANY.tva}</p>
              <p>{COMPANY.address}</p>
            </div>
          </div>

          {/* ====== Plateforme ====== */}
          <div className='footer_container_list_block'>
            <p className='footer_container_list_title'>Plateforme</p>
            <ul className='footer_links'>
              <li><Link to="/search" className='footer_link'>Rechercher un pro</Link></li>
              <li><Link to="/auth/signup/partner" className='footer_link'>Devenir ProMeet Partner</Link></li>
              <li><Link to="/missions/dashboard" className='footer_link'>ProMeet Missions</Link></li>
              <li><Link to="/auth/signup/pro" className='footer_link'>Inscription pro</Link></li>
              <li><Link to="/auth/signup/client" className='footer_link'>Inscription client</Link></li>
            </ul>
          </div>

          {/* ====== Légal ====== */}
          <div className='footer_container_list_block'>
            <p className='footer_container_list_title'>Légal</p>
            <ul className='footer_links'>
              <li><Link to="/legal/terms" className='footer_link'>Conditions générales</Link></li>
              <li><Link to="/legal/terms#mentions-legales" className='footer_link'>Mentions légales</Link></li>
              <li><Link to="/legal/terms#confidentialite" className='footer_link'>Confidentialité</Link></li>
              <li><Link to="/legal/terms#cookies" className='footer_link'>Cookies</Link></li>
            </ul>
          </div>

          {/* ====== Réseaux sociaux ====== */}
          <div className='footer_container_list_block'>
            <p className='footer_container_list_title'>Nos réseaux sociaux</p>
            <div
              className='list_icon'
              style={{ display: "flex", gap: "10px", fontSize: "24px" }}
            >
              <a
                href={SOCIAL.instagram}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="Instagram ProMeetService"
              >
                <FontAwesomeIcon icon={faInstagram} style={{ color: "#E4405F" }} />
              </a>
              <a
                href={SOCIAL.linkedin}
                target="_blank"
                rel="noreferrer noopener"
                aria-label="LinkedIn ProMeetService"
              >
                <FontAwesomeIcon icon={faLinkedin} style={{ color: "#0A66C2" }} />
              </a>
            </div>
            <p className='footer_tagline'>
              Rejoignez la communauté des pros qui prennent une longueur d'avance.
            </p>
          </div>
        </div>

        <div className='footer_bottom'>
          © {year} {COMPANY.name} — Tous droits réservés.
          <span className='footer_bottom_sep'>·</span>
          <Link to="/legal/terms" className='footer_bottom_link'>CGU / CGV</Link>
          <span className='footer_bottom_sep'>·</span>
          <Link to="/help" className='footer_bottom_link'>Aide</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
